<template>
	<modal
		:show.sync="modals.modal1"
		footerClasses="text-right"
		:largeModal="false"
	>
		<h6
			slot="header"
			class="modal-title text-success font-weight-bold"
			id="modal-title-default"
		>
			Form Pelaporan Pajak BPHTB
		</h6>
		<div class="d-block">
			<ValidationObserver v-slot="{ handleSubmit }">
				<form ref="form" @submit.stop.prevent="handleSubmit(submit)">
					<div class="alert alert-danger" v-if="error_msg.length > 0">
						<strong>Warning!</strong> Perbaiki hasil input Anda :
						<ul>
							<li v-for="text in error_msg" :key="text">{{ text }}</li>
						</ul>
					</div>
					<div class="mb-5">
						<div class="row">
							<div class="col-md-12 col-sm-12">
								<div v-if="form.file">
									<div class="form-group">
										<button
											type="button"
											color="success"
											@click="downloadFile('file')"
											size="small"
										>
											Download Surat Permohonan
										</button>
										<button
											type="button"
											style="margin-left: 5px"
											color="danger"
											@click="deleteFile('file')"
											size="small"
										>
											Hapus Surat Permohonan
										</button>
									</div>
								</div>
								<template v-else>
									<ValidationProvider
										name="Surat Pelaporan Pajak BPHTB harus di upload"
										rules="required"
										v-slot="{ validate, errors }"
									>
										<div class="form-group">
											<label>Surat Pelaporan Pajak BPHTB</label>
											<input
												type="file"
												class="form-control"
												@change="
													uploadFiles($event, 'file') || validate($event)
												"
											/>
											<span class="text-danger text-sm" v-show="errors[0]">{{
												errors[0]
											}}</span>
										</div>
									</ValidationProvider>
								</template>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 col-sm-12">
								<div class="form-group">
									<ValidationProvider
										name="Pajak yang dibayar"
										rules="required"
										v-slot="{ errors }"
									>
										<label>Pajak yang Dibayar</label>
										<money
											v-model="form.total_tax"
											v-bind="money"
											class="form-control text-right"
											placeholder="Pajak Yang dibayar"
										></money>
										<div
											class="text-danger invalid-feedback"
											style="display: block"
											v-if="errors[0]"
										>
											{{ errors[0] }}
										</div>
									</ValidationProvider>
								</div>
							</div>
						</div>
						<div class="row float-right">
							<div class="col-md-12 col-sm-12">
								<template v-if="isBusy">
									<pulse-loader
										:loading="isBusy"
										:color="'#d7f6e8'"
									></pulse-loader>
									<strong>Loading...</strong>
								</template>
								<base-button
									v-else
									type="success"
									nativeType="submit"
									icon="ni ni-send"
									>{{ edit ? "Update" : "Simpan" }}</base-button
								>
								<base-button type="warning" @click="modals.modal1 = false"
									>Tutup</base-button
								>
							</div>
						</div>
					</div>
				</form>
			</ValidationObserver>
		</div>
	</modal>
</template>
<script>
import Modal from "@/components/Modal.vue"
import PulseLoader from "vue-spinner/src/PulseLoader.vue"
import axios from "axios"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import vSelect from "vue-select"
import { Money } from "v-money"
import Datepicker from "vuejs-datepicker"
import { BTable } from "bootstrap-vue"
import qs from "qs";
import Swal from "sweetalert2"

export default {
	components: {
		Modal,
		PulseLoader,
		ValidationProvider,
		ValidationObserver,
		vSelect,
		Money,
		Datepicker,
		BTable,
	},
	data() {
		return {
			modals: {
				modal1: false,
			},
			money: {
				decimal: ",",
				thousands: ".",
				prefix: "Rp. ",
				suffix: "",
				precision: 2,
				masked: false,
			},
			form: {
				year: null,
				month: null,
				total_tax: 0,
				file: null,
			},
			isBusy: false,
			error_msg: [],
			edit: false,
		}
	},
	methods: {
		async uploadFiles(event, name) {
			const files = event.target.files
			const file = new FormData()
			file.append("file", files[0])
			let fileName = files[0]["name"]
			file.append(
				"filename",
				name + "." + fileName.substr(fileName.lastIndexOf(".") + 1)
			)
			if (files[0]["size"] > 1024 * 1024 * 2) {
				alert("File terlalu besar harus kurang dari 2MB (> 2MB)")
				return
			}
			if (
				files[0]["type"] != "image/png" &&
				files[0]["type"] != "image/jpeg" &&
				files[0]["type"] != "application/pdf"
			) {
				alert("File yang Anda upload bukan PDF/Image")
				return
			}
			try {
				let { data } = await axios.post("/api/v1/upload", file)
				this.form[name] = data
			} catch (error) {
				// console.log(error);
				this.form[name] = null
			} finally {
			}
		},
		downloadFile(name) {
			axios({
				url: "/api/v1/download_pdf?filename=" + this.form[name], //your url
				method: "GET",
				responseType: "blob", // important
			}).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement("a")
				link.href = url
				link.target = "_blank"
				link.setAttribute("download", this.form[name]) //or any other extension
				document.body.appendChild(link)
				link.click()
			})
		},
		deleteFile(name) {
			this.form[name] = null
		},
		showModal(year, month, total_tax = 0, file = null) {
			this.edit = false
			this.modals.modal1 = true
			this.form.year = year
			this.form.month = month
			this.form.total_tax = total_tax
			this.form.file = file
		},
		hideModal() {
			this.modals.modal1 = false
		},
		async submit() {
			const me = this
			try {
				me.error_msg = []
				this.isBusy = true
				let { status } = await axios.post(
					"/api/v2/pelaporan",
					qs.stringify({ pelaporan: me.form })
				)

				if (status >= 200 && status <= 202) {
					Swal.fire({
						title: "",
						text:
							"Pelaporan Pajak Berhasil, Terima kasih sudah melapor pajak Anda.",
						icon: "success",
						showCancelButton: false,
						confirmButtonColor: "#3085d6",
						confirmButtonText: "Tutup!",
					}).then(() => {
						this.$emit("refresh")
						this.hideModal()
					})
				}
				this.isBusy = false
			} catch (error) {
        console.log(error)
				this.isBusy = false
			} finally {
				this.isBusy = false
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.modal-dialog {
	max-width: 80% !important;
	margin: 1.75rem auto;
}

.uploader-example {
	padding: 15px;
	font-size: 12px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

.uploader-example .uploader-btn {
	margin-right: 4px;
}

.uploader-example .uploader-list {
	max-height: 440px;
	overflow: auto;
	overflow-x: hidden;
	overflow-y: auto;
}

.has-success:after {
	margin-top: 30px;
	content: "\EA26";
	color: #1d8357;
	background-color: #69deac;
}

.has-danger:after {
	margin-top: 30px;
	content: "\EA53";
	color: #db2d05;
	background-color: #fda08b;
}
</style>
